import React from "react";
import { Button, Upload, App } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { customUpload } from "../../../utils";

interface Props {
  value?: string;
  onChange: (url: string | undefined) => void;
  folder?: string;
  label?: string;
}

const ImageUploadInput: React.FC<Props> = ({
  value,
  onChange,
  folder = "game-quiz/images",
  label = "Subir imagen",
}) => {
  const { message } = App.useApp();
  const handleUpload = async (options: any) => {
    try {
      const { url } = await customUpload(options, folder);
      onChange(url);
      options.onSuccess?.({ url }, options.file);
      message.success("Imagen subida");
    } catch (error) {
      console.error(error);
      message.error("Error al subir la imagen");
      options.onError?.(error);
    }
  };

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      {value && (
        <img
          src={value}
          alt="preview"
          style={{
            width: 56,
            height: 56,
            objectFit: "cover",
            borderRadius: 6,
          }}
        />
      )}
      <Upload
        customRequest={handleUpload}
        showUploadList={false}
        accept="image/*"
      >
        <Button icon={<UploadOutlined />}>{label}</Button>
      </Upload>
      {value && (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onChange(undefined)}
        />
      )}
    </div>
  );
};

export default ImageUploadInput;
